export type ImageSize = 'thumb' | 'large';

const PIXELS: Record<ImageSize, number> = { thumb: 160, large: 1000 };

const AMAZON_HOSTS = new Set([
  'm.media-amazon.com',
  'images-na.ssl-images-amazon.com',
]);

/* `<id>` or `<id>._SX300_` before the extension; the modifier is replaced. */
const AMAZON_FILE = /^(\/images\/I\/[^/.]+)(?:\._[^/]*_)?(\.[A-Za-z0-9]+)$/;

function isShopifyCdn({ hostname, pathname }: URL): boolean {
  return (
    hostname === 'cdn.shopify.com' ||
    (hostname.endsWith('.myshopify.com') && pathname.startsWith('/cdn/'))
  );
}

/**
 * A listing image URL at thumbnail or large size, for the CDNs that resize on
 * request (Amazon, Shopify). Other URLs, and null, come back unchanged.
 */
export function sizedImage(url: string, size: ImageSize): string;
export function sizedImage(
  url: string | null | undefined,
  size: ImageSize,
): string | undefined;
export function sizedImage(
  url: string | null | undefined,
  size: ImageSize,
): string | undefined {
  if (!url) return undefined;

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }

  const pixels = PIXELS[size];

  if (AMAZON_HOSTS.has(parsed.hostname)) {
    const match = AMAZON_FILE.exec(parsed.pathname);
    if (!match) return url;
    parsed.pathname = `${match[1]}._SL${pixels}_${match[2]}`;
    return parsed.toString();
  }

  if (isShopifyCdn(parsed)) {
    parsed.searchParams.set('width', String(pixels));
    return parsed.toString();
  }

  return url;
}
